import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Stack, Text } from '@chakra-ui/react'

import { ProfessionalContractTypeFilter } from 'InstitutionalManagement/types'
import ProfessionalContractTypeFilterForm from 'InstitutionalManagement/components/ProfessionalContractTypeFilterForm'
import { useCustomFormProfessionalContractTypeSelectionDrawerManager } from '../../contexts/CustomFormProfessionalContractTypeSelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchProfessionalContractTypeOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<ProfessionalContractTypeFilter>({ defaultValues: { name: '' } })

  const { setView, filter, setFilter, setLoadingProfessionalContractTypes } =
    useCustomFormProfessionalContractTypeSelectionDrawerManager()

  function onSubmit(professionalContractTypeFilter: ProfessionalContractTypeFilter) {
    setFilter({ ...filter, ...professionalContractTypeFilter })
    setLoadingProfessionalContractTypes(true)
    setView('SELECT_PROFESSIONAL_CONTRACT_TYPE')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar um tipo de contrato</Text>
        <Heading color="primary">Pesquisar os tipos de contrato</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <ProfessionalContractTypeFilterForm register={register} />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar tipo de contrato</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchProfessionalContractTypeOnCustomForm
